import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FileDownloadService} from '@app/services/file-download.service';
// import {DomSanitizer} from "@angular/platform-browser";
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {DefaultUrlSerializer} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {UploadService} from '@common-components/file-upload/upload.service';
import {ToastrService} from 'ngx-toastr';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';

@Component({
    selector: 'app-attachment-thumbnails',
    templateUrl: './attachment-thumbnails.component.html',
    styleUrls: ['./attachment-thumbnails.component.css']
})
export class AttachmentThumbnailsComponent implements OnInit {

    constructor(public downloadService: FileDownloadService,
                public matDialog: MatDialog,
                public  fileUploadService: UploadService,
                public toastr: ToastrService,
                public taskService: TaskService) {
    }

    @Input() attachment;
    @Input() taskId: string;
    @Input() removePermission: boolean;

    @Output() deleteFileEmitter: EventEmitter<any> = new EventEmitter();

    extension = '';
    location = '';

    ngOnInit(): void {
        this.extension = this.attachment.extension;
        this.location = 'assets/icons/task.png';
        // if (this.extension == 'pdf') {
        //     this.location = 'assets/icons/icon-pdf.png';
        // } else if (this.extension == 'png') {
        //     this.location = 'assets/icons/icon-png.png';
        // } else if (this.extension == 'jpg') {
        //     this.location = 'assets/icons/icon-jpg.png';
        // } else if (this.extension == 'jpeg') {
        //     this.location = 'assets/icons/icon-jpeg.png';
        // } else {
        //     this.location = '/assets/icons/txt-icon.png';
        // }
    }

    download(item) {
        this.downloadService.downloadFile(item).subscribe(result => {
            if (result.type === 'success') {
                this.downloadService.urlToBase64(result);
            }
        });

    }

    async remove(attachment) {
      try{
          await this.fileUploadService.deleteFileFromStorage(attachment);
          this.toastr.success("Uspjesno obrisan fajl")
          await this.fileUploadService.removeEvent();
          this.deleteFileEmitter.emit(attachment);
      }catch (e)
      {
          this.toastr.error("Doslo je do greske prilikom brisanja fajla")
      }


    }


}
